import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full mb-3">
              Day Temizlik Hakkında
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
              Yaşam alanlarınızda hijyen, düzen ve konfor
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Day Temizlik Adana, yaşam alanlarınızda hijyen, düzen ve konforu bir araya getiren profesyonel temizlik çözümleri sunar. Daire temizliğinden bina ve site ortak alanlarına, inşaat sonrası detaylı temizlikten koltuk ve halı yıkamaya kadar ihtiyaçlarınıza uygun hizmet planı oluşturur.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Her alanın farklı bir temizlik ihtiyacı olduğunu bilir, bu nedenle kullanılacak ekipman, temizlik adımları ve çalışma süreci hizmet türüne göre belirlenir. Sarıçam ve Adana genelinde hızlı, güvenilir ve planlı hizmet anlayışıyla yanınızdayız.
            </p>
            <Link
              to="/kurumsal"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-5 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              Kurumsal hakkında bilgi alın
            </Link>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="/assets/images/about-day.jpg"
                alt="Day Temizlik Adana profesyonel ekibi"
                className="w-full h-64 md:h-80 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}